const toSentenceCase = str =>
  str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();

export default {
  toSentenceCase,
};
